import React, { useState } from 'react';
import Lottie from 'react-lottie-player';
import data from '../JSON/section2/data2';


const Data5 = () => {
    return (
        <div
            className="thumbs-up sectionimg1"
            id="lottie"
        >
            <Lottie
                loop={true}
                animationData={data}
                play
                renderer='svg'
            />
        </div>
    )
};

export default Data5;